import { TDocumentDefinitions } from "pdfmake/interfaces";

export function getPDFContent(logo64: string, qrDownload64: string, qrLogin64: string, firstName?: string, lastName?: string): TDocumentDefinitions {
  return {
    pageSize: 'A4',
    pageMargins: [40, 40, 40, 60],

    images: {
      logo: logo64,
      qrDownload: qrDownload64,
      qrLogin: qrLogin64,
    },

    content: [
      { image: 'logo', width: 200 },
      { text: 'Productivity Cloud', style: 'header', margin: [0, 80, 0, 40] },
      {
        table: {
          widths: [200, '*', 200],
          body: [
            [
              {
                stack: [
                  { text: 'Download', style: 'title', margin: [0, 0, 0, 8] },
                  { text: 'NIMMSTA App', style: 'title' },
                  { image: 'qrDownload', width: 200 },
                ],
              },
              '',
              {
                stack: [
                  { text: 'Login', style: 'title', margin: [0, 0, 0, 8] },
                  { text: 'NIMMSTA App', style: 'title' },
                  { image: 'qrLogin', width: 200 },
                ],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => 14,
          paddingRight: () => 14,
          paddingTop: () => 12,
          paddingBottom: () => 12,
          fillColor: () => '',
        },
      },
      { text: 'This page belongs to the following worker :', style: 'nameHeader', margin: [0, 100, 0, 20] },
      { text: firstName || '', style: 'name', margin: [0, 0, 0, 0] },
      { text: lastName || '', style: 'name', margin: [0, 0, 0, 40] },
    ],

    styles: {
      header: { fontSize: 32, bold: true, alignment: 'center' },
      title: { fontSize: 24, bold: true, alignment: 'center' },
      nameHeader: { fontSize: 24, bold: true },
      name: { fontSize: 18, bold: true },
    },
  };
}
